import { Controller } from '@hotwired/stimulus';
import axios from 'axios';

export default class extends Controller {
    async loadMorePosts(event) {
        let { page } = event.target.dataset;
        const response = await axios.get(`/news`, {
            params: {
                page
            }
        });

        Turbo.renderStreamMessage(response.data);

        page = parseInt(page) + 1;
        event.target.dataset.page = page;
        console.log(event.target.dataset.page);
    }
}